import _app from "../../../views/_app.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "404": dynamic(() => import("../../../views/404.tsx"), "views/404.tsx"),
  "_app": _app,
  "archive-insight": dynamic(() => import("../../../views/archive-insight.tsx"), "views/archive-insight.tsx"),
  "archive-leadership": dynamic(() => import("../../../views/archive-leadership.tsx"), "views/archive-leadership.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-insight": dynamic(() => import("../../../views/single-insight.tsx"), "views/single-insight.tsx"),
  "single-leadership": dynamic(() => import("../../../views/single-leadership.tsx"), "views/single-leadership.tsx"),
  "taxonomy-insight-category": dynamic(
    () => import("../../../views/taxonomy-insight-category.tsx"),
    "views/taxonomy-insight-category.tsx",
  ),
  "taxonomy-insight-type": dynamic(
    () => import("../../../views/taxonomy-insight-type.tsx"),
    "views/taxonomy-insight-type.tsx",
  ),
  "template-contact": dynamic(() => import("../../../views/template-contact.tsx"), "views/template-contact.tsx"),
  "template-generic": dynamic(() => import("../../../views/template-generic.tsx"), "views/template-generic.tsx"),
  "template-home": dynamic(() => import("../../../views/template-home.tsx"), "views/template-home.tsx"),
  "template-product": dynamic(() => import("../../../views/template-product.tsx"), "views/template-product.tsx"),
  "template-terms": dynamic(() => import("../../../views/template-terms.tsx"), "views/template-terms.tsx"),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
